<template>
  <div class="chat">
    <van-nav-bar left-text="返回" left-arrow @click-right="$router.back()" right-text="关闭">
      <div slot="left" class="flex aic f999">
        <van-icon class="f999" name="service-o" />
        <span>客服妹子</span>
      </div>
    </van-nav-bar>

    <!-- 聊天列表 -->
    <ul class="list">
      <li class="item">
        <!-- 客服 -->
        <div class="l flex mt-25">
          <img class="kefu" src="../../assets/img/kefu.png" alt />
          <div class="talk flex2 ml-10">
            <span class="f777 f14">小鲜</span>
            <p
              class="mt-5 bg-fff msg f14"
            >只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行</p>
          </div>
        </div>

        <!-- 我 -->
        <div class="r flex mt-25 jc-e">
          <div class="talk flex2 mr-15">
            <!-- <span class="f777 f14 flex jc-e">我</span> -->
            <p
              class="mt-5 bg-fff msg f14"
            >只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行只有一行</p>
          </div>
          <img class="kefu" src="../../assets/img/me.jpeg" alt />
        </div>
      </li>
    </ul>

    <!-- 输入框 -->
    <div class="inp flex jc-sb aic bg-fff pl-15 pr-15">
      <div class="icons flex aic">
        <van-icon name="smile-o" />
        <van-icon name="photo-o" />
        <van-icon name="good-job-o" />
      </div>
      <van-field class="fg1" v-model="msg" placeholder="请输入" />
      <span class="red">发送</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "",
      path: "ws://localhost:3007/socket?user=zhangsan",
      socket: ""
    };
  },
  created() {
    //  this.getList();
    this.init();
  },

  methods: {
    init: function() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.path);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
      }
    },
    open: function() {
      console.log("socket连接成功");
    },
    error: function() {
      console.log("连接错误");
    },
    getMessage: function(msg) {
      console.log(msg.data);
    },
    send: function() {
      this.socket.send(params);
    },
    close: function() {
      console.log("socket已经关闭");
    },
    destroyed() {
      // 销毁监听
      this.socket.onclose = this.close;
    },

    submit() {
      let data = {
        user: "admin",
        message: this.msg
      };
      this.socket.send(JSON.stringify(data));
    }
  }
};
</script>

<style lang="less">
.chat {
  .van-nav-bar .van-icon {
    color: #999;
  }
  bottom: 0;
  .van-cell {
    width: 0;
  }
  .inp {
    height: 50px;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  .icons {
    .van-icon {
      margin-left: 3px;
    }
  }
  .list {
    margin-top: 10px;
    padding: 0 10px;
  }
  .item {
    .l,
    .r {
      max-width: 70vw;
    }
    .l {
      float: left;
    }
    .r {
      float: right;
    }
    .kefu {
      height: 40px;
      // width: 40px!important;
      background: #fff;
    }
  }

  .talk {
    .msg {
      padding: 10px;
      border-radius: 5px;
      position: relative;
      &:after {
        content: "";
        position: absolute;
        border: 1px solid;
      }
    }
  }

  .l .talk {
    .msg {
      &:after {
        left: -14px;
        top: 8px;
        border-top: 7px solid transparent;
        border-left: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-right: 7px solid #fff;
      }
    }
  }
  .r .talk {
    .msg {
      &:after {
        content: "";
        right: -14px;
        top: 8px;
        border-top: 7px solid transparent;
        border-left: 7px solid #fff;
        border-bottom: 7px solid transparent;
        border-right: 7px solid transparent;
      }
    }
  }
}
</style>